module.exports = __webpack_public_path__ + "img/banner.cf96bde1.png";